import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar-area" }
const _hoisted_2 = { class: "mobile-nav" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "navbar navbar-expand-md navbar-light" }
const _hoisted_5 = {
  class: "collapse navbar-collapse mean-menu",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav m-auto" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = { class: "nav-item alignCenter" }
const _hoisted_13 = { class: "nav-item alignCenter" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = { class: "nav-item alignCenter" }
const _hoisted_17 = { class: "nav-item alignCenter" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = { class: "nav-item alignCenter" }
const _hoisted_24 = { class: "nav-item alignCenter" }
const _hoisted_25 = { class: "nav-item alignCenter" }
const _hoisted_26 = { class: "nav-item alignCenter" }
const _hoisted_27 = { class: "nav-item alignCenter" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = { class: "menu-btn" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "preloader" }, [
      _createElementVNode("div", { class: "preloader-wave" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: "logo",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.goHome && _ctx.goHome(...args)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: "static/picture/logo.png",
            alt: "Logo"
          }, null, -1)
        ]))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{'top-nav':$data.isActive},'main-nav'])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _createElementVNode("a", {
              class: "navbar-brand",
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: "static/picture/logo.png",
                alt: "Logo"
              }, null, -1)
            ])),
            _createElementVNode("a", {
              class: "navbar-brand-sticky",
              onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: "static/picture/logo.png",
                alt: "Logo"
              }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    "data-lang": "menu.home",
                    to: "/",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Home")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _cache[22] || (_cache[22] = _createElementVNode("a", { class: "nav-link" }, [
                    _createElementVNode("span", { "data-lang": "menu.product" }),
                    _createElementVNode("i", { class: "bx bxs-chevron-right" })
                  ], -1)),
                  _createElementVNode("ul", _hoisted_9, [
                    _createElementVNode("li", _hoisted_10, [
                      _cache[10] || (_cache[10] = _createElementVNode("a", { class: "nav-link" }, [
                        _createElementVNode("span", { "data-lang": "menu.sms" }),
                        _createElementVNode("i", { class: "bx bx-chevron-right" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_11, [
                        _createElementVNode("li", _hoisted_12, [
                          _createVNode(_component_router_link, {
                            to: "/sms",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createElementVNode("img", {
                                src: "static/image/iconYZM.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", { "data-lang": "foot.product.otp" }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_13, [
                          _createVNode(_component_router_link, {
                            to: "/market",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createElementVNode("img", {
                                src: "static/image/iconYxYzm.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", { "data-lang": "foot.product.marketing" }, null, -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_14, [
                      _cache[13] || (_cache[13] = _createElementVNode("a", { class: "nav-link" }, [
                        _createElementVNode("span", { "data-lang": "menu.voice" }),
                        _createElementVNode("i", { class: "bx bx-chevron-right" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_15, [
                        _createElementVNode("li", _hoisted_16, [
                          _createVNode(_component_router_link, {
                            to: "/voice",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createElementVNode("img", {
                                src: "static/image/iconYX.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", { "data-lang": "product.voice" }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            to: "/trunk",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createElementVNode("img", {
                                src: "static/image/iconSIP.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "SIP Trunk", -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        "data-lang": "menu.emailHome",
                        to: "/email",
                        class: "nav-link"
                      })
                    ]),
                    _createElementVNode("li", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        "data-lang": "menu.phone",
                        to: "/phoneCheck",
                        class: "nav-link"
                      })
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                      _createVNode(_component_router_link, {
                        to: "/esim",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode(" ESIM ")
                        ])),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_21, [
                      _cache[21] || (_cache[21] = _createElementVNode("a", { class: "nav-link" }, [
                        _createTextVNode(" WhatsApp "),
                        _createElementVNode("i", { class: "bx bx-chevron-right" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_22, [
                        _cache[20] || (_cache[20] = _createElementVNode("li", { class: "nav-item alignCenter" }, [
                          _createElementVNode("a", {
                            href: "https://docs-yoni-tech.readme.io/reference/whatsapp_message-send",
                            target: "_blank",
                            class: "nav-link"
                          }, [
                            _createElementVNode("img", {
                              src: "static/image/iconWAP.png",
                              alt: ""
                            }),
                            _createElementVNode("span", null, "WhatsApp API")
                          ])
                        ], -1)),
                        _createElementVNode("li", _hoisted_23, [
                          _createVNode(_component_router_link, {
                            to: "/campaign",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createElementVNode("img", {
                                src: "static/image/email-campaign.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Campaign", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_24, [
                          _createVNode(_component_router_link, {
                            to: "/bot",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createElementVNode("img", {
                                src: "static/image/bot.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Chatbot", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_25, [
                          _createVNode(_component_router_link, {
                            to: "/contact",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createElementVNode("img", {
                                src: "static/image/contact.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Contact", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_26, [
                          _createVNode(_component_router_link, {
                            to: "/inbox",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createElementVNode("img", {
                                src: "static/image/inbox.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Inbox", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_27, [
                          _createVNode(_component_router_link, {
                            to: "/growthTool",
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createElementVNode("img", {
                                src: "static/image/growth.png",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Growth Tool", -1)
                            ])),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("li", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    "data-lang": "menu.price",
                    to: "/price",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode("Home")
                    ])),
                    _: 1
                  })
                ]),
                _cache[24] || (_cache[24] = _createStaticVNode("<li class=\"nav-item\" data-v-5f182e46><a class=\"nav-link\" data-v-5f182e46><span data-lang=\"menu.docment\" data-v-5f182e46></span><i class=\"bx bxs-chevron-right\" data-v-5f182e46></i></a><ul class=\"dropdown-menu\" data-v-5f182e46><li class=\"nav-item\" data-v-5f182e46><a class=\"nav-link\" href=\"https://docs-yoni-tech.readme.io/reference/sms_getting-started\" target=\"_blank\" data-v-5f182e46><img src=\"static/image/iconSMS.png\" alt=\"\" data-v-5f182e46><span data-v-5f182e46>SMS</span></a></li><li class=\"nav-item\" data-v-5f182e46><a class=\"nav-link\" href=\"https://docs-yoni-tech.readme.io/reference/voice_sip-trunk\" target=\"_blank\" data-v-5f182e46><img src=\"static/image/voicesIcon.png\" alt=\"\" data-v-5f182e46><span data-v-5f182e46>Voice</span></a></li><li class=\"nav-item\" data-v-5f182e46><a class=\"nav-link\" href=\"https://docs-yoni-tech.readme.io/reference/email_getting-started\" target=\"_blank\" data-v-5f182e46><img src=\"static/image/mailbox.png\" alt=\"\" data-v-5f182e46><span data-v-5f182e46>Email</span></a></li><li class=\"nav-item\" data-v-5f182e46><a class=\"nav-link\" href=\"https://docs-yoni-tech.readme.io/reference/whatsapp_getting-started\" target=\"_blank\" data-v-5f182e46><img src=\"static/image/whatsappIcon.png\" alt=\"\" data-v-5f182e46><span data-v-5f182e46>WhatsApp</span></a></li><li class=\"nav-item\" data-v-5f182e46><a class=\"nav-link\" href=\"https://docs-yoni-tech.readme.io/reference/check_getting-started\" target=\"_blank\" data-v-5f182e46><img src=\"static/image/jiancheIcon.png\" alt=\"\" data-v-5f182e46><span data-v-5f182e46> Number Check</span></a></li></ul></li>", 1)),
                _createElementVNode("li", _hoisted_29, [
                  _createVNode(_component_router_link, {
                    "data-lang": "menu.about",
                    to: "/about",
                    class: "nav-link"
                  })
                ]),
                _cache[25] || (_cache[25] = _createStaticVNode("<li class=\"nav-item\" data-v-5f182e46><a class=\"nav-link\" data-v-5f182e46><span data-lang=\"menu.language\" data-v-5f182e46></span><i class=\"bx bxs-chevron-right\" data-v-5f182e46></i></a><ul class=\"dropdown-menu\" data-v-5f182e46><li class=\"nav-item\" data-v-5f182e46><a id=\"zhBtn\" class=\"nav-link\" data-v-5f182e46> 简体中文 </a></li><li class=\"nav-item\" data-v-5f182e46><a id=\"enBtn\" class=\"nav-link\" data-v-5f182e46> English </a></li></ul></li>", 1))
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = (...args) => ($options.loginClick && $options.loginClick(...args))),
                  "data-lang": "menu.login",
                  class: "seo-btn"
                })
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}